export default "__VITE_ASSET__BztoY2SM__"